import React from "react";
import Player from "./Player";
import Totals from "./Totals";
import Skins from "./Skins";
import DogMeat from "./DogMeat";
import HoleScore from "./HoleScore";
import "./PlayerHole.css";
// import { useStateValue } from "./StateProvider";
// import {  holes } from "./CourseInfo";


function PlayerHole({ id }) {

  // const [{ scores }] = useStateValue();
  // const [{ skins }, dispatch3] = useStateValue();

  return (
    <div key= {id} className="playerhole">
      <div className="player__namestats">
        <div className="playerhole__name">
          <Player id={id} />
        </div>
        <div className="playerhole__summary">
          <Totals id={id} />
          <Skins id={id} />
          <DogMeat id={id}/>   {/* button only shows on par 3'3  */}
        </div>
      </div>
      <div>
      <HoleScore id={id} />
      </div>
    </div>
  );
}

export default PlayerHole;
